import { apiFetch } from "./api";

export interface UserAdminRow {
  id: string;
  email: string;
  employeeId: number | null;
  employeeName: string | null;
  roles: string[];
  lockedOut: boolean;
  lastLoginUtc: string | null;
}
export interface UserPage {
  items: UserAdminRow[];
  total: number;
  page: number;
  pageSize: number;
}
export interface CreatedUser {
  id: string;
  email: string;
  generatedPassword: string;
}

export const usersAdminApi = {
  list: (q = "", page = 0, pageSize = 50): Promise<UserPage> =>
    apiFetch<UserPage>(
      `/api/admin/users?page=${page}&pageSize=${pageSize}${q ? `&q=${encodeURIComponent(q)}` : ""}`,
    ),
  setRoles: (id: string, roles: string[]): Promise<void> =>
    apiFetch<void>(`/api/admin/users/${id}/roles`, { method: "PUT", body: JSON.stringify({ roles }) }),
  lock: (id: string): Promise<void> => apiFetch<void>(`/api/admin/users/${id}/lock`, { method: "POST" }),
  unlock: (id: string): Promise<void> => apiFetch<void>(`/api/admin/users/${id}/unlock`, { method: "POST" }),
  resetPassword: (id: string): Promise<{ generatedPassword?: string } | void> =>
    apiFetch<{ generatedPassword?: string } | void>(`/api/admin/users/${id}/reset-password`, { method: "POST" }),
  create: (email: string, roles: string[]): Promise<CreatedUser> =>
    apiFetch<CreatedUser>(`/api/admin/users`, { method: "POST", body: JSON.stringify({ email, roles }) }),
};

export const ALL_ROLES = ["Admin", "SalesLead", "Sales", "Production", "Artwork", "Finance", "ReadOnly"] as const;
